import React from "react";
import "./App.css";
import "animate.css";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Home from "./components/pages/Home/Home";
import About from "./components/pages/About/About";
import SponsorCard from "./components/pages/Sponsors/Sponsor/SponsorCard";
import OurTeam from "./components/pages/OurTeam/OurTeam";
import AllEvents from "./components/pages/Events/AllEvents";
import ClubEvents from "./components/pages/Events/ClubEvents/ClubEvents";
// import Committe from "./components/pages/Events/Committe";
import Gallary from "./components/pages/Gallary/Gallary";
import Contact from "./components/pages/Contact/Contact";
import Footer from "./components/Footer/Footer";
import Error from "./components/pages/ErrorPage/Error";
import Everegister from "./components/RegisterLogin/EventRegistrationCards/everegister";
// import PortFolio from './components/aothers/portfolio comp/portfolio';

function App() {
  return (
    <>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="events" element={<AllEvents />}>
            <Route path="clubevent" element={<ClubEvents />} />
            <Route path="committe" element={<Error />} />
          </Route>
          <Route path="gallary" element={<Gallary />} />
          <Route path="sponsors" element={<SponsorCard />} />
          <Route path="ourteam" element={<OurTeam />} />
          <Route path="contact" element={<Contact />} />
          <Route path="register" element={<Everegister />} />
          <Route path="cr" element='Still in Updating Stage... Not Yet Done! ....' />
          <Route path="*" element={<Error />} />
        </Routes>
        <Footer />
      </div>
    </>
  );
}

export default App;
